import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [['MC', 'Marcela C.', 'Buenos Aires', 'A los 12 días dejé el omeprazol. Pensé que era algo que iba a necesitar de por vida.'], ['LP', 'Laura P.', 'Córdoba', 'El semáforo de alimentos me mostró que la cebolla era mi disparador.'], ['SR', 'Sergio R.', 'Rosario', 'Fui al gastroenterólogo con todo organizado. Me dijo que nunca había visto un paciente tan preparado.']] as const;
const extended = [['Marcela C.', 'Buenos Aires', '“Llevaba 4 años con hinchazón crónica. A las 3 semanas dejé el omeprazol. Jamás pensé que era tan sencillo cuando sabés qué hacer.”'], ['Laura P.', 'Córdoba', '“El semáforo me mostró que la cebolla era mi disparador. Algo que ningún médico me había dicho en años de consultas.”'], ['Sergio R.', 'Rosario', '“No tengo tiempo para cocinar cosas raras. El recetario express me cambió la vida. Todo en 15 minutos con ingredientes del súper.”'], ['Claudia M.', 'Mendoza', '“Empecé con escepticismo total. Al día 10 los cambios eran tan evidentes que se lo recomendé a tres compañeras.”']] as const;
function Stars() {
  return <div className="flex gap-1 text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-171" data-mp="1lc7nrdzp4d30">
      {[1, 2, 3, 4, 5].map(item => <StarIcon key={item} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-172" data-mp="1qd54dm524z2e" />)}
    </div>;
}
export function StatsAndProof() {
  const stats = [['+320', 'personas aplicando el protocolo'], ['5', 'Volúmenes completos'], ['5', 'Bonos incluidos'], ['4.9/5', 'calificación']];
  return <>
      <section className="border-y border-brand-green/20 bg-brand-ink px-4 py-14 sm:py-20" data-id="element-173" data-mp="248z35cc4a81s">
        <div className="mx-auto grid max-w-3xl grid-cols-2 gap-x-5 gap-y-10" data-id="element-174" data-mp="292btbqwg2mwn">
          {stats.map(([value, label]) => <div key={label} className="text-center" data-id="element-175" data-mp="2e2pqgdwiccfw">
              <p className="font-display text-4xl font-bold sm:text-6xl" data-id="element-176" data-mp="2i2zz5ybopgyg">{value}</p>
              <p className="mt-2 text-xs font-semibold leading-tight text-brand-light sm:text-sm" data-id="element-177" data-mp="2n0s17l61mjgd">{label}</p>
            </div>)}
        </div>
      </section>

      <section className="bg-brand-dark px-4 py-16 sm:py-20" data-id="element-178" data-mp="mwz7ty25nprf">
        <div className="mx-auto grid max-w-6xl gap-5 md:grid-cols-3" data-id="element-179" data-mp="iyhxl5nftz5s">
          {testimonials.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="rounded-2xl border border-white/10 bg-brand-ink p-6" data-id="element-180" data-mp="wq6b9ddc4vov" data-mpi={index}>
              <div className="flex items-center gap-3" data-id="element-181" data-mp="1fnqykg0gbm7d">
                <div className="grid h-11 w-11 place-items-center rounded-full border border-brand-green/40 font-bold text-brand-light" data-id="element-182" data-mp="1fn7ht2mjf3ux">{initials}</div>
                <div data-id="element-183" data-mp="3heuar9pzp8u1">
                  <h3 className="font-bold" data-id="element-184" data-mp="3heawc2zjt2kr">{name}</h3>
                  <p className="text-sm text-slate-400" data-id="element-185" data-mp="3hgxawmkuwich">{place}</p>
                </div>
              </div>
              <div className="mt-5" data-id="element-186" data-mp="1rxyrrit5n14f"><Stars data-id="element-187" data-mp="1rxgow3bzlonj" /></div>
              <p className="mt-4 italic leading-relaxed text-slate-300" data-id="element-188" data-mp="1rz9tld31hysw">“{quote}”</p>
            </motion.article>)}
        </div>
      </section>
    </>;
}
export function ExtendedTestimonials() {
  return <section className="border-y border-white/10 bg-brand-dark px-4 py-14 sm:py-20" data-id="element-189" data-mp="1j4vhtkhpx6ej">
      <div className="mx-auto max-w-5xl" data-id="element-190" data-mp="1n6gub4qcbio7">
        <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-191" data-mp="1n55nsx5ifwte">
          LO QUE DICEN QUIENES YA LO TIENEN
        </h2>
        <div className="grid gap-7 md:grid-cols-2" data-id="element-192" data-mp="1e7lind4j1gdi">
          {extended.map(([name, place, quote]) => <article key={name} className="border-l-2 border-brand-green pl-4" data-id="element-193" data-mp="107kglucj02wg">
              <Stars data-id="element-194" data-mp="147uojcjvp3dy" />
              <p className="mt-2 font-bold" data-id="element-195" data-mp="149fhwyugiga8">{name} <span className="font-normal text-slate-400" data-id="element-196" data-mp="14agwhdaolkwp">· {place}</span></p>
              <p className="mt-2 text-sm italic leading-relaxed text-slate-300" data-id="element-197" data-mp="2ulbr0w2oiqsy">{quote}</p>
            </article>)}
        </div>
      </div>
    </section>;
}